export class Pagination {
  rows?: any [] = [];
  columns?: any [] = [];
  limit?: number = 10;
  count?: number = 0;
  offset?: number = 0;
  message?: string = "Aún no has realizado <br> ninguna búsqueda.";
  sorts?: any[] = [{prop: "default", dir: "desc"}];
}
